export enum TypePage {
  Test = 1,
  Kanban = 2
}